const EditIcon = () => {

    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.9832 13.7688L14.1211 15H0V0H11.25L10.1995 1.25H1.25V13.75H14.9832V13.7688ZM13.7346 12.5H14.9849L14.9959 3.75506L13.7441 5.27925L13.7346 12.5ZM5.69081 10.6864L6.9815 10.1504L15.0306 0.850812L14.0858 0.0329375L6.03644 9.33225L5.69081 10.6864Z" fill="#111113" />
        </svg>
    )
}

export default EditIcon
